import React from "react";
import {CardBody, CardText, CardTitle} from "reactstrap";
import ReportStatus from "./reportStatus";

const ReportCard = ({data}) => {
  const {name, report_id, created_at} = data;
  return (
    <CardBody>
      <CardTitle tag="h4">
        Name <CardText>{name}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Status
        <CardText>
          <ReportStatus data={data} />
        </CardText>
      </CardTitle>
      <CardTitle tag="h4">
        Report Id <CardText>{report_id}</CardText>{" "}
      </CardTitle>
      <CardTitle tag="h4">
        Created At <CardText>{created_at}</CardText>{" "}
      </CardTitle>
    </CardBody>
  );
};

export default ReportCard;
